import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import "./choose-us.css";

import ReactPlayer from "react-player";
import { Link } from "react-router-dom";

const chooseImg1 = `
image/pn3.png
`;
const chooseImg2 = `
image/pn4.png
`;
const chooseImg3 = `
image/pn1.png
`;
const chooseImg4 = `
image/pn2.png
`;

const VideoItemEl = () => {
    return (
        <section>
            <Container className="video-sub-container">
                <h1 className="protect_taital">Matplotlib және Plotly</h1>
                <div className="video-sub-container-title" style={
                    {
                        fontSize: '20px',
                        fontWeight: 'bold',
                        padding: '10px',
                    }
                }>
                    2D және 3D графиктерімен жұмыс істеу үшін біз Matplotlib және Plotly кітапханаларының тиісті мүмкіндіктерін пайдалана аламыз. Мысалы, материалдық нүктенің қозғалыс траекториясының 3D графигін құру үшін біз plotly функциясын қолдана аламыз.graph_objs.Scatter3d.
                </div>
                <div className="video-sub-container-title" style={
                    {
                        fontSize: '20px',
                        fontWeight: 'bold',
                        padding: '10px',
                    }
                }>
                    Осылайша, Python тілін және қажетті кітапханаларды пайдалана отырып, PyCharm бағдарламалау ортасында физикалық тапсырмалар мен графиктермен жұмыс істеу әртүрлі ғылыми және техникалық мәселелерді шешу үшін өте пайдалы болуы мүмкін.
                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/problems#1"><img className="rightpic" src="./image/1/1-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Сақина үшін электростатикалық өрістің кернеулігін есептеу программасын құралық (1-сурет).  </b></p>
                        </div>
                        <div className="container-context-description">
                            <p>
                                Бұл код Python бағдарламалау тілінде жазылған және z осі бойындағы қашықтықтан электр өрісі функциясының 3D графигінің анимациясын жасау үшін қолданылады.
                            </p>
                            <p>
                                Зарядталған дискіден орын алған электростатикалық өрістің кернеулігін есептейтін программа құрайық.
                                Кодтың түпкі мақсаты-электр өрісінің z осіндегі зарядқа дейінгі қашықтыққа тәуелділігін сызу.
                            </p>
                        </div>
                        <br /><br /><br />
                    </div>

                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/problems#2">
                            <img className="rightpic" src="./image/2/2-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Екі параллель зарядталған жіптерден пайда болған электр өрісінің кернеулігін есептейтін программа құрастырайық</b></p>
                        </div>
                        <div className="container-context-description">
                            <p>Бұл кодта біз екі параллель зарядталған сым арқылы пайда болатын электр өрісінің кернеулігінің таралуын есептейміз және көреміз. Біз өріс кернеулігінің формуласын қолданамыз, ол сымдардан қашықтыққа байланысты.</p>
                            <p>Біз Кулон тұрақтысы, сызықтық заряд тығыздығы, сымдар арасындағы қашықтық, өріс кернеулігін есептеу үшін нүктелер саны және х координатасын дискретизациялау үшін сегменттің ұзындығы сияқты қажетті тұрақтылар мен айнымалыларды орнатудан бастаймыз.</p>
                            <p>Осыдан кейін matplotlib кітапханасының көмегімен 3D сюжетін саламыз. Біз x, y және z координаттарын орнатамыз, содан кейін өріс кернеулігінің таралуын графикте көреміз.
                            </p>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/problems#3">
                            <img className="rightpic" src="./image/3/3-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Екі параллель зарядталған жіптерден пайда болған z=0 жазықтығындағы  электр өрісі кернеулігінің күш сызықтарын тұрғызатын программа құрастырайық</b></p>
                        </div>
                        <div className="container-context-description">
                            <p>
                                Иә, графикті барлық бұрыштардан көру үшін айналдыруға болады. Ол үшін matplotlib.animation кітапханасынан FuncAnimation әдісін пайдалануға болады.
                                Міне, алдыңғы мысалдағы графикті z осінің айналасында айналдыратын кодтың мысалы
                            </p>
                            <p>
                                Бұл кодта ax.view_init әдісі арқылы графикті z осінің айналасында i бұрышына айналдыратын жаңарту функциясын анықтаймыз. Содан кейін біз осы функция негізінде анимация нысанын жасаймыз және анимацияны көрсету үшін plt.show() шақырамыз.
                            </p>
                            <p>
                                Func Animation әдісіндегі frames параметрі update функциясындағы s параметрі қабылдайтын мәндер массиві болуы керек екенін ескеріңіз.  Бұл мысалда график Z ​​осінің айналасында айналуы үшін 0-ден 360-қа дейінгі мәндер массивін 1 градус қадамымен жасау үшін np.linspace қолданамыз
                            </p>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/magnetostatics-problems#36.1">
                            <img className="rightpic" src="./image/36.1/36.1-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Электрондық-сәулелік түтікше катушкасының ауытқыту аймағындағы электрон шоғының траекториясы</b></p>
                        </div>
                        <div className="container-context-description">
                            <p>
                                Бұл код біртекті магнит өрісінде электрон қозғалатын спираль сызығының радиусын және оның қадамын анықтау мәселесін шешеді, сонымен қатар электрон траекториясының 3D графигін салады.
                            </p>
                            <p>
                                График x, y және z координаталық осьтері бар үш өлшемді кеңістікте салынған. У осі электрон жылдамдығының бағытына сәйкес келеді, х осі электрон қозғалысының жазықтығына перпендикуляр және жылдамдық векторы мен магнит индукциясы векторының векторлық көбейтіндісіне бағытталған. z осі – магниттік индукция векторы бойымен бағытталған.
                            </p>
                            <p>
                                Графикте магнит өрісінің электр зарядына әсер етуі нәтижесінде алынған спираль түріндегі электронның траекториясы көрсетілген. Кодты орындау кезінде график электронның траекториясын толық көрсету үшін автоматты түрде 360 градусқа айналады
                            </p>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/electromagnetic-induction-phenomenon#56">
                            <img className="rightpic" src="./image/56/56-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Уақыттың өзгерісіндегі конденсатодағы кереудің өсуі UC (B) – сол жақта және тоқ күшінің кемуі I(A) – оң жақта. Релаксация уақыты</b></p>
                        </div>
                        <div className="container-context-description">
                            <p>
                                Осы кодпен жасалған график C конденсаторының q зарядының және ондағы U кернеуінің t=0 уақытында K қосқышы жабылғаннан кейінгі t уақытқа тәуелділігін көрсетеді.  График конденсаторды зарядтау процесін визуализациялауға мүмкіндік береді және берілген электр тізбегінде конденсатордағы заряд пен кернеу уақыт бойынша қалай өзгеретінін көрсетеді. Сонымен қатар, бағдарлама K қосқышы жабылғаннан кейін t_1=1,0 мкс уақытында конденсатордағы q зарядын және U_C кернеуін есептеуге мүмкіндік береді.
                            </p>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/electromagnetic-induction-phenomenon#57">
                            <img className="rightpic" src="./image/57/57-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Уақыттың өзгерісіндегі конденсатодағы зарядтың өсуі q (Кл) – оң жақта және кернеудің өсуі UC (B –  сол жақта. Релаксация уақыты</b></p>
                        </div>
                        <div className="container-context-description">
                            <p>Графиктің мақсаты - индуктивтілігі мен параллель қосылған кедергісі бар катушкасы бар тізбекте тұрақты ток көзі өшірілгеннен кейін уақытында R кедергісіне ЭҚК-нің тәуелділігін және R кедергісіне бөлінген жылу мөлшерін көрсету. Кодтың қысқаша мазмұны - ЭҚК мәндерін есептеу және шығару, жылу мөлшері мен уақыт тұрақтысы, содан кейін Q-ның уақытқа және ЭҚК-ге қарсы 3D сызбасын құру.</p>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
                <div className="video-sub-container-main-body">
                    <div className="container-left">
                        <Link to="/electromagnetic-induction-phenomenon#59">
                            <img className="rightpic" src="./image/59/59-мысал.gif" /></Link>
                        <div className="container-context-title">
                            <br /><br /><br />
                            <p><b>Тізбекті ажыратқаннан кейінгі өздік индукция электр қозғаушы күші – сол жақта, кедергіде бөлініп шығатын жылу мөлшерінің қуаты –  оң жақта. Релаксация уақыты</b></p>
                        </div>
                        <div className="container-context-description">
                            <p>t уақытқа байланысты U_C конденсаторындағы кернеудің өзгеру графигі және t уақытына байланысты конденсатордағы I ток күшінің өзгеру графигі. Әрбір графиктегі x және y осьтері сәйкесінше t/tau уақытын және U_C немесе ток I кернеуінің мәнін көрсетеді. z осі U_C немесе I мәнін әрбір t уақытында көрсетеді. Графиктердің мақсаты конденсатор тұрақты ток көзінен зарядталған сәттен бастап уақыт бойынша конденсатордағы U_C және I өзгерістерін визуалды түрде көрсету болып табылады.</p>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default VideoItemEl;
